import { sendEventToAnalytics } from '@lib/helpers/client'

export default function footerSearchJobsButtonEvent(): void {
  const eventName = 'Footer - Search Button Click'
  const payload = {}
  sendEventToAnalytics(eventName, payload)
}
